import { Editor } from 'grapesjs';
import { getLocalizedProperty } from '@loyalty/shared-common';
import { sanitizeEditorCanvasHtml } from './sanitize-editor-canvas-html';

export interface GrapesjsComponent {
  el: any;
  model: any;
  getContent(): Promise<string>;
  listenTo(model: any, event: string, cb: (event?: any) => void): void;
}

export function renderLocalizedComponent(target: GrapesjsComponent, i18n: Editor['I18n']) {
  const { el, model } = target;
  const { i18nAttributes = {} } = model.attributes;
  const locale = i18n.getLocale();

  const content = getLocalizedProperty({ i18nAttributes }, 'content', locale);
  if (content) {
    el.innerHTML = sanitizeEditorCanvasHtml(content, el.ownerDocument?.defaultView ?? null);
  }
}
